import React, { FC } from 'react';
import { Separator } from '../components/Separator';
import { BalanceWidget } from '../components/BalanceWidget';
import { MainLayout } from '../layouts/MainLayout';
import { WelcomeWidget } from '../components/widget/WelcomeWidget';

export const Home: FC = () => (
  <MainLayout>
    <WelcomeWidget />
    <Separator size="S" />
    <BalanceWidget />
  </MainLayout>
);
